import { IDS } from '../../settings-action-id.constants';
import * as Actions from "../../../requirements-assessment/requirements-assessment.actions";

/**
 * Creates a list of applicable sites.
 * @class
 */
export const evidenceApplicableSites = {
    /* @ngInject */
    controller: function ($ngRedux, $uiRouterGlobals, $state, $stateParams, $scope) {
        /**
         * @function $onInit
         */
        this.$onInit = async () => {
            this.identifier = `${IDS.accSettings}.${IDS.evidenceApplicableSites}`;
            this.parentState = IDS.app_accreditation_scheme_settings_evidence;
            this.currentState = $uiRouterGlobals.current.name;

            this.unsubscribe = $ngRedux.connect(state => {
                const accSettings = state.accreditation.accSettings;
                return {
                    sectionsTree:               state.accreditation.simpleSectionsTree,
                    evidenceDetails:            accSettings.evidenceDetails,
                    allSites:                   accSettings.evidenceApplicableSitesGrid.items.map(item => item.slo_uuid),
                    applicableSites:            accSettings.evidenceApplicableSitesGrid.itemsSelect,
                    schemeName:                 accSettings.frameworkDetails.title,
                    selectedHeadOfficeName:     accSettings.selectedHeadOfficeName,
                }
            }, {
                ...Actions,
            })(this);

            this.unsubscribeGridCheckboxChange = $scope.$on('grid-checkbox-change', this.onCheckboxChange.bind(this));
            this.title = this.evidenceDetails.name;
            this.schemeCode = $stateParams.itemCode;
        }

        this.onCheckboxChange = (event, slo_uuid, isSelected, path) => {
            if (isSelected) {
                this.reactivateEvidenceForSite( this.evidenceDetails.ard_id, slo_uuid ).then( () => {
                    // $ngRedux.dispatch({
                    //     type: GRID_RELOAD,
                    //     id: IDS.accSettings,
                    //     path: IDS.evidenceApplicableHeadOfficesGrid,
                    // });
                });
            }
            else {
                this.deactivateEvidenceForSite(
                    this.evidenceDetails.ard_id,
                    slo_uuid,
                    undefined,
                    'COMMON.SERVER_RESPONSE.ITEM_DISABLED'
                ).then( () => {
                    // $ngRedux.dispatch({
                    //     type: GRID_RELOAD,
                    //     id: IDS.accSettings,
                    //     path: IDS.evidenceApplicableHeadOfficesGrid,
                    // });
                });
            }
        }

        this.$onDestroy = () => {
            this.unsubscribe();
            if (this.unsubscribeGridCheckboxChange) {
                this.unsubscribeGridCheckboxChange();
            }
        }
    },
    template: `
        <div style="padding:20px 10px">
            <evidence-applicable-sites-grid
                title="{{$ctrl.title}}">
            </evidence-applicable-sites-grid>
        </div>
        <tabs-navigation identifier="{{$ctrl.parentState}}"
                         state="{{$ctrl.currentState}}"
                         on-exec="$ctrl.onSubmit()">
        </tabs-navigation>
`};